module.exports = window.FormData



//////////////////
// WEBPACK FOOTER
// ./~/isomorphic-form-data/lib/browser.js
// module id = 505
// module chunks = 0